module.exports = __webpack_public_path__ + "static/media/ico-star-full.14471d75.svg";